import type { TeeBox } from '@/lib/api/types';

/**
 * A CSS colour for a tee box.
 *
 * The backend stores `color` as a free-form string, so it may be a hex value, a colour word,
 * or something unusable. The design fixes a palette by tee name (canvas 1a, "cores de tee
 * box"), which is the reliable fallback — a scorecard where "Azul" renders grey is worse
 * than one that ignores a malformed field.
 */

const BY_NAME: Record<string, string> = {
  preto: 'var(--tee-black)',
  black: 'var(--tee-black)',
  azul: 'var(--tee-blue)',
  blue: 'var(--tee-blue)',
  branco: 'var(--tee-white)',
  white: 'var(--tee-white)',
  amarelo: 'var(--tee-yellow)',
  yellow: 'var(--tee-yellow)',
  vermelho: 'var(--tee-red)',
  red: 'var(--tee-red)',
  // The seeded Pelotas course names its tees by position, not colour.
  front: 'var(--tee-white)',
  back: 'var(--tee-blue)',
};

const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export function teeColor(tee: Pick<TeeBox, 'name' | 'color'>): string {
  const byName = BY_NAME[tee.name.trim().toLowerCase()];
  if (byName) return byName;

  const raw = tee.color?.trim() ?? '';
  if (HEX.test(raw)) return raw;

  const byColorWord = BY_NAME[raw.toLowerCase()];
  if (byColorWord) return byColorWord;

  return 'var(--terrain-tee)';
}
